import { useMemo } from 'react';

import { ContentBlockRendererProps } from '../../types/ContentBlockRendererProps';
import { evaluateDescription } from './logic/evaluateDescription';
import { evaluateHeading } from './logic/evaluateHeading';

export const useContentBlockRenderer = (
  description: ContentBlockRendererProps['description'],
  heading: ContentBlockRendererProps['heading'],
  workflowDataResolverDependencies: ContentBlockRendererProps['workflowDataResolverDependencies'],
) => {
  const evaluatedHeading = useMemo(
    () => evaluateHeading(heading, workflowDataResolverDependencies),
    [heading, workflowDataResolverDependencies],
  );

  const evaluatedDescription = useMemo(
    () => evaluateDescription(description, workflowDataResolverDependencies),
    [description, workflowDataResolverDependencies],
  );

  return {
    evaluatedHeading,
    evaluatedDescription,
  };
};
